export default "__VITE_ASSET__Bak057T$__"